import { z } from 'zod';

export const pineappleSchema = z.object({ id: z.string(), name: z.string() });

export interface Pineapple {
    id: string;
    name: string;
}
